export const AUTH_SESSION_HINT_KEY = 'otw-had-session';

export const readAuthSessionHint = (): boolean => {
  try {
    return sessionStorage.getItem(AUTH_SESSION_HINT_KEY) === '1';
  } catch {
    return false;
  }
};

export const writeAuthSessionHint = (hadSession: boolean) => {
  try {
    if (hadSession) {
      sessionStorage.setItem(AUTH_SESSION_HINT_KEY, '1');
      return;
    }
    sessionStorage.removeItem(AUTH_SESSION_HINT_KEY);
  } catch {
    /* private mode */
  }
};
